import type { IMetricViewTimePill } from './date-presets';

/**
 * Maps the active time pill + range to a human-readable sublabel used under
 * summary tiles ("Period total · Q1 2026", "Avg per week · last 4 weeks"…).
 */
export function formatPeriodLabel(pill: IMetricViewTimePill): string {
  if (pill.preset === 'Q1' || pill.preset === 'Q2' || pill.preset === 'Q3' || pill.preset === 'Q4') {
    const year = pill.year ?? new Date().getUTCFullYear();
    return `${pill.preset} ${year}`;
  }
  if (pill.preset === 'YTD') {
    const year = pill.year ?? new Date().getUTCFullYear();
    return `YTD ${year}`;
  }
  if (pill.preset === 'full-year') {
    const year = pill.year ?? new Date().getUTCFullYear();
    return `Full Year ${year}`;
  }
  // rolling presets — 2w, 4w, 8w
  const longerWeeks = pill.preset === '4w' ? 4 : 8;
  const weeks = pill.preset === '2w' ? 2 : longerWeeks;
  return `Last ${weeks} weeks`;
}

/**
 * Count weeks spanned by an ISO range [from, to]. Used to label "last N weeks"
 * when the active window is shorter than the intended rolling window size.
 */
export function weeksInRange(from: string, to: string): number {
  const fromMs = new Date(from).getTime();
  const toMs = new Date(to).getTime();
  const days = Math.ceil((toMs - fromMs) / (1000 * 60 * 60 * 24)) + 1;
  return Math.max(1, Math.round(days / 7));
}

export function rollingAvgLabel(from: string, to: string, targetWeeks: number): string {
  const actual = Math.min(targetWeeks, weeksInRange(from, to));
  return `Avg per week · last ${actual} week${actual === 1 ? '' : 's'}`;
}
